import { createSlice } from "@reduxjs/toolkit";

const initialDatasetState = {
  dataset: {
    file_id: "",
    user_id: "",
    file_type: "",
    event_name: "",
    event_day: "",
    event_id: "",
    tags: [],
    wp_id: "",
    transcript: {
      text: "",
      segments: [],
    },
    speakers: [],
    moderator: "",
    title: "",
    upload_date: "",
    description: "",
    transcript_status: "",
    report_status: "",
    report: {},
    report_url:""
  },
};

const datasetSlice = createSlice({
  name: "dataset",
  initialState: initialDatasetState,
  reducers: {
    setDataset(state, action) {
      state.dataset = action.payload;
    },
    updateDataset(state, action) {
      state.dataset = { ...state.dataset, ...action.payload };
    },
  },
});

export const { setDataset, updateDataset } = datasetSlice.actions;

export default datasetSlice.reducer;
